import React, { useEffect, useRef } from "react";
import "./predictionBox.css";

// IMAGE IMPORTING
import TimeIcon from "../../../assets/icon/Time.svg";
import { useState } from "react";
import teamImage from "../../../utilities/constants.json";
import Moment from "moment";
import { predictGameAnswer } from "../../../services/questionApi";
import { useCountdown } from "../../../utilities/timer";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useUpdateQuestions } from "../../../hooks/useUpdateQuestions";
import PredictionCountDown from "./PredictionCountDown";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const imageUrl = teamImage.team_image;

const PredictionBoxDrop = (prop) => {
  const [openTimeOut, setOpenTimeOut] = useState(false);
  const [openPleaseLogin, setOpenPleaseLogin] = useState(false);
  const { days, hours, minutes, seconds } = useCountdown(
    prop.data.que_time_qatar_string,
  );
  const [userPrediction, setUserPrediction] = useState();
  const { updateQuestions } = useUpdateQuestions();

  const fixtureUrl = prop?.data?.fixture?.fix_url;

  const handleTimeOutClose = () => {
    setOpenTimeOut(false);
  };

  const handlePleaseLoginClose = () => {
    setOpenPleaseLogin(false);
  };

  const validate = (e) => {
    if (!localStorage.webKey) {
      e.preventDefault();
      setOpenPleaseLogin(true);
      return;
    }

    let currentDate = Moment.utc()
      .utcOffset(teamImage.timeOffset)
      .format("YYYY-MM-DDTHH:mm:ss");

    if (time <= new Date(currentDate).getTime()) {
      e.preventDefault();
      setOpenTimeOut(true);
    }
  };

  const index = parseInt(prop.index) + 1;

  const [answer, setAnswer] = useState();

  const time = React.useMemo(
    () =>
      new Date(
        Moment(prop?.data?.que_time_qatar_string, "YYYY-MM-DD HH:mm:ss").format(
          "MMM DD, YYYY HH:mm:ss",
        ),
      ).getTime(),
    [prop?.data?.que_time_qatar_string],
  );

  const [timeFlag, setTimeFlag] = useState(false);

  let currentDate = Moment.utc()
    .utcOffset(teamImage.timeOffset)
    .format("YYYY-MM-DD HH:mm:ss");
  const [options, setOption] = useState([]);

  useEffect(() => {
    setTimeFlag(false);
    setDefaultData();
    setOptions();
  }, [prop?.data?._id?.$oid, prop?.data?.user_prediction?.answer]);

  function setDefaultData() {
    let stime = new Date(
      Moment(prop.data.que_time_qatar_string, "YYYY-MM-DD HH:mm:ss").format(
        "MMM DD, YYYY HH:mm:ss",
      ),
    ).getTime();
    if (stime < new Date(Date.parse(currentDate)).getTime()) {
      setTimeFlag(true);
    }

    if (prop?.data?.que_answer || prop?.data?.user_prediction?.answer) {
      setUserPrediction(
        prop?.data?.que_answer || prop?.data?.user_prediction?.answer,
      );
    } else {
      setUserPrediction("");
    }
  }

  function setOptions() {
    let optiondata = [];

    optiondata.push({ value: "", label: "Please choose", disabled: true });

    prop.data.que_answer_option.map((item) => {
      optiondata.push({ value: item, label: item });
    });
    setOption(optiondata);
  }
  function markAnswer(data) {
    if (localStorage.webKey) {
      let currentDate = Moment.utc()
        .utcOffset(teamImage.timeOffset)
        .format("YYYY-MM-DDTHH:mm:ss");

      if (time > new Date(currentDate).getTime()) {
        setAnswer(data);

        console.log("data", prop.data.fixture);
        !!data
          ? prop.updateAnswers({
              fixture_id: prop.data.fixture._id["$oid"],
              question_id: prop.data._id["$oid"],
              answer: data,
            })
          : prop.updateAnswers(
              {
                fixture_id: prop.data.fixture._id["$oid"],
                question_id: prop.data._id["$oid"],
                answer: data,
              },
              true,
            );
      } else {
        setOpenTimeOut(true);
      }
    } else {
      setOpenPleaseLogin(true);
    }
  }

  function predictAnswer() {
    predictGameAnswer({
      question_id: prop.data._id["$oid"],
      answer: answer,
      fixture_id: prop.data.fixture._id["$oid"],
    })
      .then((res) => {
        if (res.data.status == 1) {
          setUserPrediction(answer);
          updateQuestions(prop.data._id["$oid"], answer);
        } else {
          if (res.data.status == 101) {
            localStorage.clear();
            setOpenPleaseLogin(true);
          } else {
            if (res.data.message == "Time out!") {
              setOpenTimeOut(true);
            }
          }
        }
      })
      .catch(() => {});
  }

  const handleOpen = (teamUrl) => {
    if (!fixtureUrl && !teamUrl) return;

    let url = "";

    let currentDate = Moment.utc()
      .utcOffset(teamImage.timeOffset)
      .format("YYYY-MM-DDTHH:mm:ss");

    if (time > new Date(currentDate).getTime()) url = teamUrl;
    else url = fixtureUrl || teamUrl;
    
    if (!!url) window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div key={prop?.data?._id?.$oid} className="predictionBox">
      <div className="predictionBox-grid">
        <div className="predictionBox-item">
          <div className="predictionBox-itemWrapper">
            <div className="predictionBox-topSection">
              <div className="predictionBox-top-part1">
                <div className="predictionBox-groupTime-wrapper">
                  {/* <h6 className="matchText">M1</h6>
                    <h6 className="timeText">9:30 PM</h6>
                    <h6 className="groupText">GROUP A</h6> */}
                  <h6 className="groupText">Qn No. {index}</h6>
                </div>
                <div className="predictionBox-points-wrapper">
                  <p className="predictionBox-points">
                    {prop.data.que_points} Points
                  </p>
                </div>
                {!prop.isPostponed && (<div className="predictionBox-remainingTime-wrapper">
                  <div className="predictionBox-timeImg">
                    <img
                      className={
                        time >
                        new Date(
                          Date.parse(
                            Moment.utc()
                              .utcOffset(teamImage.timeOffset)
                              .format("YYYY-MM-DDTHH:mm:ss"),
                          ),
                        ).getTime()
                          ? "time-icon"
                          : "time-icon-selected"
                      }
                      src={TimeIcon}
                      alt=""
                    />
                    {/* <img className="time-icon-selected" src={TimeIcon} alt="" /> */}
                  </div>
                  <PredictionCountDown
                    timeString={prop?.data?.que_time_qatar_string}
                  />
                </div>)}
              </div>
              <div className="predictionBox-top-part2">
                <div className="predictionBox-questionWrapper">
                  <p className="predictionBox-question">
                    {localStorage.language == "en"
                      ? prop.data.question
                      : prop.data.que_malayalam}
                  </p>
                </div>
              </div>
            </div>
            <div className="predictionBox-bottomSection">
              <div className="row d-flex justify-content-center px-1 p-lg-0">
                <div className="col-2 d-flex justify-content-center px-1 px-lg-3">
                  <div
                    className={
                      fixtureUrl || prop.data.fixture.fix_team_a?.team_url
                        ? "predictionBox-teamOne"
                        : "predictionBox-inactive"
                    }
                    onClick={() =>
                      handleOpen(prop.data.fixture.fix_team_a?.team_url)
                    }
                  >
                    <img
                      src={imageUrl + prop.data.fixture.fix_team_a.team_flag}
                      alt="Team 1"
                    />
                  </div>
                </div>
                {/* <div className="col-8 d-flex justify-content-center px-1 p-lg-0"> */}
                <div className="col-8 d-flex justify-content-center">
                  <div className="predictionBox-predictionWrapper">
                    <div className="predictionBox-prediction-dropDown">
                      <div className="prediction-dropDown-wrapper">
                        <select
                          onChange={(e) => markAnswer(e.target.value)}
                          name="country-code"
                          id="country-code"
                          onMouseDown={validate}
                          className="prediction-dropDown-select"
                        >
                          {options
                            ? options.map((item, index) => (
                                <option
                                  key={index}
                                  value={item.value}
                                  disabled={item.disabled}
                                  selected={
                                    item.value == prop.data.que_answer ||
                                    item.value == userPrediction
                                      ? "selected"
                                      : ""
                                  }
                                >
                                  {item.label}
                                </option>
                              ))
                            : ""}
                        </select>
                      </div>
                    </div>
                    <p className="bottomText">
                      {prop.data.user_prediction?.answer
                        ? "Your Prediction : " + prop.data.user_prediction?.answer
                        : timeFlag || prop.data.que_answer
                          ? "Oops! You missed this prediction "
                          : "Tap to choose your prediction"}
                    </p>
                  </div>
                </div>
                {/* </div> */}

                <div className="col-2 d-flex justify-content-center px-1 px-lg-3">
                  <div
                    className={
                      fixtureUrl || prop.data.fixture.fix_team_b?.team_url
                        ? "predictionBox-teamOne"
                        : "predictionBox-inactive"
                    }
                    onClick={() =>
                      handleOpen(prop.data.fixture.fix_team_b?.team_url)
                    }
                  >
                    <img
                      src={imageUrl + prop.data.fixture.fix_team_b.team_flag}
                      alt="Team 1"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="predictionBox-questionShare-wrapper">
              <div className="share-icon">
                <img src={ShareAlt} alt="" />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="timeOverModal">
        <Dialog
          open={openTimeOut}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleTimeOutClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="timeOverModal-wrapper">
            <div className="timeOverModal-header">
              <h2>Time Over !!!</h2>
            </div>
            <div className="timeOverModal-content">
              <p>You can't change the prediction.</p>
              {/*<p>You cant the change the prediction now.</p>*/}
              {/*<p>You cant the change the prediction now.</p>*/}
            </div>

            <div className="timeOverModal-button-wrapper">
              <Button
                onClick={handleTimeOutClose}
                className="timeOverModal-login-btn"
              >
                GOT IT
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
      <div className="pleaseLoginModal">
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          PLEASE LOG IN
        </Button> */}
        <Dialog
          open={openPleaseLogin}
          TransitionComponent={Transition}
          keepMounted
          onClose={handlePleaseLoginClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="pleaseLoginModal-wrapper">
            <div className="pleaseLoginModal-header">
              <h2>Not Logged In!</h2>
            </div>
            <div className="pleaseLoginModal-content">
              <p>Please login/register to start predicting.</p>
            </div>

            <div className="pleaseLoginModal-button-wrapper">
              <Link to="/mobile-login">
                <Button className="pleaseLoginModal-login-btn">LOGIN</Button>
              </Link>
              <Link to="/mobile-register">
                <Button className="pleaseLoginModal-register-btn">
                  REGISTER
                </Button>
              </Link>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default PredictionBoxDrop;
